import { Component, OnInit, AfterViewChecked, ViewChild } from '@angular/core';
import { CategoryService, Category } from 'app/services/category.service';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Image } from 'app/services/image.service';
import { BaseComponent } from 'app/components/base.component';
import { NotificationsService } from "angular2-notifications";

@Component({
	selector: 'app-add-category',
	templateUrl: './category-form.html',
})
export class AddEditCategoryComponent extends BaseComponent implements OnInit {
	item:Category;
	formTitle = 'Add New Category';
    buttonText = 'Save Category';
    param_id   : string;
	error:any;
	
	categories:Category[];

    catForm: NgForm;
	@ViewChild('catForm') currentForm: NgForm;

	constructor(
		private categoryService: CategoryService,
		private router: Router,
		private route: ActivatedRoute,
		private notificationsService: NotificationsService
	) {
		super();
	}

	ngOnInit() {
        this.param_id = this.route.snapshot.params['id'];
        this.item = new Category();
        if (this.param_id) {
			this.formTitle  = 'Edit Category';
			this.buttonText = 'Update Category';
			this.categoryService.getCategory(this.param_id).subscribe(category => {
				this.item = Object.assign(new Category(), category);
			});
		}

		var self = this;
		this.categoryService.getCategories().subscribe((categories) => {
			this.categories = categories.filter((item, index) => {
				return self.param_id != item.$key && !item.parent_id;
			})
		});
	}

	formAction() {
		var self = this;
        var imageCheck = this.item.image;
        if (this.formValidation(false) && imageCheck) {
			this.error = '';
			this.transformer();
            if (this.param_id) {
                this.categoryService.updateCategory(this.route.snapshot.params['id'], this.item).then(function(){
					self.notificationsService.success('Updated','1 category updated')
				}).catch(function(e){
					console.log('There is an error. '+e.message);
				});
            } else {
                this.categoryService.addCategory(this.item).then(function(){
					self.notificationsService.success('Added','1 category added')
				}).catch(function(e){
					console.log('There is an error. '+e.message);
				});
            }
            this.router.navigate(['/category']);
		} if(imageCheck) {
			this.error = '';
		} else {
            this.error = 'No Image selected';
        }
	}

	transformer(){
		this.item.order_number = this.item.order_number + '';
	}

	imageSelected(image: Image) {
        this.item.image = image.url[0]
        this.error = '';
    }

    onRemove(){
        this.item.image = '';
    }

    ngAfterViewChecked() {
		this.formChanged();
	}

	formChanged() {
		if (this.currentForm === this.catForm) { return; }

		this.catForm = this.currentForm;
		if (this.catForm) {
			this.catForm.valueChanges
				.subscribe(data => {
					this.formValidation(true)

					if(this.item.goes_to == 'sub') {
						this.item.parent_id = '';
					}
				});
		}
	}

	formValidation(checkDirty = true) {
		const form = this.catForm.form;
		for (const field in form.controls) {
			const control = form.get(field)
			if (control) {
				if (checkDirty && !control.dirty) {
					continue;
				}
				this.formErrors[field] = '';
				if (!control.valid) {
					const messages = this.validationMessages[field] || {};
					for (const key in control.errors) {
						this.formErrors[field] += messages[key] + ' ';
					}
				}
			}
		}

		return form.valid;
	}

	formErrors = {
		name : '',
		order_number: ''
	};

	validationMessages = {
		'name': {
			'required': 'This field is required.',
		},
	};
}



// WEBPACK FOOTER //
// D:/www/kh_indesso_web/src/app/components/category/add-edit-category.component.ts